var _styled;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { BLACK, GREY_1, YELLOW } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT, SPACING } from '@govuk-react/constants';
var BreadcrumbContainer = styled('div')((_styled = {
  fontFamily: NTA_LIGHT,
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled.marginTop = SPACING.SCALE_3, _styled.WebkitFontSmoothing = 'antialiased', _styled));
var BreadcrumbList = styled('ul')({
  margin: 0,
  padding: 0,
  listStyleType: 'none',
  display: 'block'
});
var BreadcrumbListItem = styled('li')({
  position: 'relative',
  display: 'inline-block',
  whiteSpace: 'no-wrap',
  marginBottom: SPACING.SCALE_1,
  marginLeft: SPACING.SCALE_2,
  paddingLeft: SPACING.SCALE_3,
  ':first-child': {
    marginLeft: 0,
    paddingLeft: 0,
    '::before': {
      display: 'none'
    }
  },
  '::before': {
    content: "''",
    display: 'block',
    position: 'absolute',
    top: '-1px',
    bottom: '1px',
    left: '-3.31px',
    width: '7px',
    height: '7px',
    margin: 'auto 0',
    transform: 'rotate(45deg)',
    border: 'solid',
    borderWidth: '1px 1px 0 0',
    borderColor: "" + GREY_1
  },
  '> a': {
    color: "" + BLACK,
    textDecoration: 'underline',
    ':focus': {
      backgroundColor: "" + YELLOW,
      outline: "3px solid " + YELLOW
    }
  }
});
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <Breadcrumb>
 *   <a href="/section">Section</a>
 *   <a href="/section/sub-section">Sub-section</a>
 *   Current page
 * </Breadcrumb>
 * ```
 *
 * Using `asAnchor` HOC with, or without React Router
 * ```jsx
 * import { Link } from 'react-router-dom';
 * import { asAnchor } from '@govuk-react/hoc';
 *
 * const AnchorLink = asAnchor(Link);
 * const AnchorTag = asAnchor('a');
 *
 * <Breadcrumb>
 *   <AnchorLink to="/section">Section</AnchorLink>
 *   <AnchorTag href="/section">Sub-section</AnchorTag>
 * </Breadcrumb>
 * ```
 *
 * ### References:
 * - https://github.com/alphagov/govuk-frontend/blob/master/src/components/breadcrumb/_breadcrumb.scss
 *
 * ### TODO:
 * - Consider using the context API https://github.com/reactjs/rfcs/blob/master/text/0002-new-version-of-context.md
 * - Consider nested anchors, create an Atom for Breadcrumb links?
 *
 */

var Breadcrumb = function Breadcrumb(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(BreadcrumbContainer, props, React.createElement(BreadcrumbList, null, children.length && children.map ? children.map(function (child, i) {
    return child && (child.length || child.props) ? React.createElement(BreadcrumbListItem, {
      key: child.key || i
    }, child) : null;
  }) : React.createElement(BreadcrumbListItem, null, children)));
};

export default withWhiteSpace({
  marginBottom: 2
})(Breadcrumb);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/breadcrumb/es/index.js
// module id = 152
// module chunks = 0